import React from 'react'
import {ImageOverlay} from 'react-leaflet'

// REDUX IMPORTS
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import * as HeatMapActions from '../../../actions/heatmaps'
import L from "leaflet";


const HeatMap = props => {

        return(<div>
            {props.tiles.map( (tile, key) => {
                return (
                    <ImageOverlay onLoad={props.heatMapsActions.increaseLoadedMaps}
                                  bounds={L.latLngBounds([tile.NE, tile.SW])}
                                  url={'/bet-mapgenerator/' + tile.url}
                                  opacity={props.opacity ? 1 : (props.opacityTran ? 0.3 : 0)}
                                  className={'tiles-base'}
                                  key={key}
                    />
                );
            })}
        </div>)

};

const mapDispatchToProps = (dispatch) => {
    return {
        heatMapsActions: bindActionCreators(HeatMapActions, dispatch),
    }
};

export default connect(null, mapDispatchToProps)(HeatMap)



// WEBPACK FOOTER //
// ./src/components/Map/MapComponents/HeatMap.js